

import { defaultCacheAsideExecutor } from './CacheAsideExecutor';
import { invalidateAccountListCache } from '../../services/account';

/**
 * Drops in-memory client caches (campaign list, accounts list, etc.) on logout or
 * account switch.
 *
 * SOC 2: avoid serving one tenant's cached API data after session/account boundary
 * changes. Missing an in-memory cache here has caused login-as-different-account to
 * inherit the previous tenant's account list, which then redirects the new session
 * back to the old account URL and produces 403s (authorizeAccountAccess mismatch).
 */
export function clearClientSessionCaches() {
  defaultCacheAsideExecutor.clear();
  invalidateAccountListCache();
}
